import * as React from "react";
const SvgBurgerMenu = (props) => /* @__PURE__ */ React.createElement("svg", { height: 24, width: 24, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m24 6.712v-2.712h-24v2.712zm0 6.552v-2.544h-24v2.544zm0 6.72v-2.712h-24v2.712z", fill: "#000" }));
export default SvgBurgerMenu;
